export default __webpack_public_path__ + "static/media/EM1340.34I-36203_-21256_0.8bd91cc1.jpg";